import { useUserSotre } from '@/store/modules/user';
// import { setToken as localSetToken, setRefreshToken, getToken } from '@/utils/token';
import { initSSE } from '@/utils/sse';
// import { sleep } from '@/utils/u7buy';
import { memberInfo } from '@/api/index';
export default function () {
  const { routerLocalePath } = useRouteLink();
  const { setToken: setSotreToken, setMemberInfo, getNewFcCustomer, state } = useUserSotre();
  // accessToken
  // 设置token
  const setToken = (accessToken: string, refreshToken: string) => {
    // pina 存一份
    setSotreToken(accessToken, refreshToken);
  };
  // 注册登录统一跳转方式
  const loginBehavior = async (url: string, isHref: boolean = true) => {
    console.log(url, '跳转');
    const res = await memberInfo();
    // 登录成功后 会员信息存入缓存
    setMemberInfo(res.data);
    getNewFcCustomer();
    // sleep(1500);
    initSSE(`${import.meta.env.VITE_APP_PATH_SSE}/member/indexSse`);
    if (isHref) {
      routerLocalePath(url, 'replace');
    }
  };
  // 是否登录
  const isLogin = () => {
    return state.accessToken;
  };
  return {
    setToken,
    loginBehavior,
    isLogin
  };
}
